<template>
  <div class="page-content prose">
    <div class="container">
      <div class="flex justify-center pb-8">
        <ContentInfoLinks />
      </div>

      <h1>Rijschool in Tilburg zoeken?</h1>
      <p>
        Ben je op zoek naar de beste of voordeligste rijschool in Tilburg? Via
        Rijscholenvergelijker.nl kom je er binnen de kortste keren achter bij
        welke rijschool in Tilburg je het beste rijles kunt gaan nemen. Hier heb
        je namelijk gratis en vrijblijvend de kans om informatie aan te vragen
        van verschillende rijscholen in je eigen regio. Welke rijschool heeft
        het laagste tarief? Welke rijschool heeft de beste statistieken? Binnen
        één minuut heb je je gegevens op de website ingevuld, waarna je de
        volgende dag al wordt benaderd door verschillende rijscholen in Tilburg.
        Laat je goed informeren, kies de beste rijschool en haal snel en
        voordelig je rijbewijs!
      </p>

      <h2>Gratis, vrijblijvend, snel en effectief</h2>
      <p>
        Je kunt ervoor kiezen om met elke rijschool in Tilburg en omstreken
        afzonderlijk contact op te nemen, maar waarom zou je
        Rijscholenvergelijker.nl niet het werk laten doen? Wij selecteren op
        basis van je postcode immers de rijscholen die het dichtst bij jou in de
        buurt actief zijn. Zij nemen zo snel mogelijk contact met je op en
        daarna is het natuurlijk aan jou om deze rijscholen in Tilburg met
        elkaar te vergelijken. Let daarbij op het uurtarief, maar bedenk ook
        waar jij denkt het minste aantal lesuren nodig te hebben!
      </p>

      <h2>Rijscholen in Tilburg en de rest van Nederland</h2>
      <p>
        Zoals je op Rijscholenvergelijker.nl op zoek kunt gaan naar de beste
        rijschool van Tilburg, kun je hier uiteraard ook terecht als je
        rijscholen in een andere regio in Nederland zoekt. Vraag snel informatie
        aan en wij zorgen dat je wordt benaderd door meerdere regionale
        <nuxt-link to="/"> rijscholen </nuxt-link>. Simpeler kan het niet!
      </p>
      <p>
        Niet alleen voor het
        <nuxt-link to="/informatie-over-rijscholen"> rijbewijs </nuxt-link>
        waarmee je personenauto’s mag besturen ben je hier aan het goede adres;
        ook als je bijvoorbeeld je
        <nuxt-link to="/informatie-over-rijscholen/rijbewijs-A">
          motorrijbewijs
        </nuxt-link>
        of
        <nuxt-link to="/informatie-over-rijscholen/rijbewijs-c">
          rijbewijs C
        </nuxt-link>
        voor vrachtwagens wilt gaan halen, biedt Rijscholenvergelijker.nl
        uitkomst. Profiteer vandaag nog!
      </p>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContentInfoLinks from '~/components/layout/ContentInfoLinks'

export default {
  components: {
    ContentInfoLinks,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle:
        'Rijschool in Tilburg zoeken? Kijk op Rijscholenvergelijker.nl!',
      headDescription:
        'Zoek je naar een rijschool in Tilburg waar je snel en voordelig je rijbewijs kunt halen? Op Rijscholenvergelijker.nl vraag je gratis offertes aan!',
    }
  },
}
</script>
